// Option 1: Custom Hook (Recommended)
// hooks/useDynamicColumns.js
import { useMemo } from "react";

export const useDynamicColumnDefs = (rowData, columnDefs, options = {}) => {
  const {
    alwaysShowFields = [], // Fields to always show regardless of data
    hideEmptyColumns = true, // Toggle functionality on/off
    emptyValues = [null, undefined, "", "N/A"], // What constitutes "empty"
    checkTrimmedStrings = true, // Whether to trim strings before checking
  } = options;

  // Helper function to check if all values in a field are empty
  const isFieldEmpty = (fieldName) => {
    if (!rowData || rowData.length === 0) return true;

    return rowData.every((row) => {
      const value = row[fieldName];

      // Check against defined empty values
      if (emptyValues.includes(value)) return true;

      // Check trimmed strings if enabled
      if (
        checkTrimmedStrings &&
        typeof value === "string" &&
        value.trim() === ""
      ) {
        return true;
      }

      return false;
    });
  };

  const filteredColumnDefs = useMemo(() => {
    if (!hideEmptyColumns) return columnDefs;

    return columnDefs.filter((colDef) => {
      // Always show fields specified in alwaysShowFields
      if (alwaysShowFields.includes(colDef.field)) return true;

      // For other columns, check if the field has any non-empty values
      return !isFieldEmpty(colDef.field);
    });
  }, [rowData, columnDefs, alwaysShowFields, hideEmptyColumns]);

  return filteredColumnDefs;
};

/**
 * Usage Example:
 * 
    const dynamicColumnDefs = useDynamicColumnDefs(rowData, columnDefs, {
      alwaysShowFields: ["firstName"], // Always show name column
      emptyValues: [null, undefined, "", "N/A", "TBD"], // Custom empty values
    });
 */
